import Texas from '../../utils/layers/RACs/Texas/data/texas.json'
import { geoContains,GeoGeometryObjects } from 'd3'
import { Vehicle, VehicleLocation } from 'server'

export const inTexas = (location: VehicleLocation | undefined) => geoContains(Texas.geometry as GeoGeometryObjects, [location?.longitude, location?.latitude])

/**
 * Convert degrees to direction
 */
export const degreesToDirection = (degrees: string | number): string => {
  // Try to convert to number
  degrees = Number(degrees)
  if (isNaN(degrees)) {
    return ''
  }
  if (degrees > 337.5 || degrees <= 22.5) {
    return 'North'
  } else if (degrees > 22.5 && degrees <= 67.5) {
    return 'NorthEast'
  } else if (degrees > 67.5 && degrees <= 112.5) {
    return 'East'
  } else if (degrees > 112.5 && degrees <= 157.5) {
    return 'SouthEast'
  } else if (degrees > 157.5 && degrees <= 202.5) {
    return 'South'
  } else if (degrees > 202.5 && degrees <= 247.5) {
    return 'SouthWest'
  } else if (degrees > 247.5 && degrees <= 292.5) {
    return 'West'
  } else if (degrees > 292.5 && degrees <= 337.5) {
    return 'NorthWest'
  }
  return ''
}

/**
 * Group and display agency ids of vehicles
 */
export const groupAgencyIds = (vehicles: Vehicle[]) => {
  const agencyIdMap = new Map()
  for (const vehicle of vehicles) {
    if (agencyIdMap.has(vehicle.agency_id)) {
      agencyIdMap.set(vehicle.agency_id, agencyIdMap.get(vehicle.agency_id) + 1)
    } else {
      agencyIdMap.set(vehicle.agency_id, 1)
    }
  }
  return agencyIdMap
}
